import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

import { select, Selection } from 'd3-selection';

export abstract class AbstractComponent<ConfigType extends Config, DataType> {

  protected containerElement: Selection;

  private _config: ConfigType;
  private _data: DataType;

  private resizeObserver;

  constructor(containerEl: HTMLElement, params: Params<ConfigType, DataType> = {}) {
    this.containerElement = select(containerEl);

    this.config = Object.assign(this.getDefaultConfig(), params.config);
    if (!!params.data) {
      this.data = params.data;
    }

    const ResizeObserver = (window['ResizeObserver'] || ResizeObserverPolyfill);
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { height, width } = entry.contentRect;
        this.resize({ height, width });
      });
    });
    this.resizeObserver.observe(containerEl);
  }

  public update(params: Params<ConfigType, DataType>): void {
    if (!!params.config) {
      this.config = Object.assign(this.config, params.config);
    }
    if (!!params.data) {
      this.data = params.data;
    }
  }

  public destroy(): void {
    this.resizeObserver.disconnect();
  }

  protected get config(): ConfigType {
    return this._config;
  }

  protected set config(config: ConfigType) {
    this._config = config;
  }

  protected getDefaultConfig(): any {
    return {
      locale: 'en',
      transitionsDurationInMillis: 500
    };
  }

  protected get data(): DataType {
    return this._data;
  }

  protected set data(data: DataType) {
    this._data = data;
  }

  protected getElementSize(element: HTMLElement): Size {
    return {
      height: element.getBoundingClientRect().height,
      width: element.getBoundingClientRect().width
    };
  }

  protected resize(containerElSize: Size): void {}

}

export interface Params<ConfigType, DataType> {
  config?: Partial<ConfigType>;
  data?: DataType;
}

export interface Config {
  locale: string;
  transitionsDurationInMillis: number;
}

export interface Size {
  height: number;
  width: number;
}
